/**
 * Kintsu sMON (Monad) rate surface.
 *
 * sMON is a custom (non-ERC-4626) native-MON LST: it carries no
 * `asset()`/`convertToAssets(uint256)`, but exposes `totalPooled()` (total
 * MON staked) and `totalShares()` (total sMON). The 1e18-scaled exchange
 * rate is derived from their ratio — equivalent to the contract's own
 * `convertToAssets(uint96)` (verified on-chain).
 */
export const KintsuSMonAbi = [
  {
    name: 'totalPooled',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'totalShares',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
